import { LOGIN } from 'actions/Types';

export default function loginError(state = null, action) {
  if (action.type === LOGIN) {
    return null;
  }
  if (action.type === `${LOGIN}_FAILURE`) {
    return action.payload;
  }

  return state;
}
